import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=564cdc06&scoped=true"
import script from "./rank.vue?vue&type=script&lang=ts"
export * from "./rank.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564cdc06",
  null
  
)

export default component.exports